import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './HotelHeader.scss';
import Button from '../../UI/Button/Button';
import SliderSlide from '../../Slider/SliderSlide/SliderSlide';

class HotelHeader extends Component {
    
    state = {
        images: this.props.hotelImages,
        currentIndex: 0,
        translateValue: 0
    }

    goToPrevSlide = () => {
        if(this.state.currentIndex === 0) return;
        this.setState(prevState => ({
            currentIndex: prevState.currentIndex - 1,
            translateValue: prevState.translateValue + 920
        }))
    }

    goToNextSlide = () => {
        if(this.state.currentIndex === this.state.images.length - 1) {
            return this.setState({
                currentIndex: 0,
                translateValue: 0
            })
        }
        this.setState(prevState => ({
            currentIndex: prevState.currentIndex + 1,
            translateValue: prevState.translateValue - 920
        }));
    }

    render() {
        const stars = [];

        if(this.props.detailStar) {
            for(let i = 0; i < this.props.detailStar; i++) {
                stars.push(<span key={i}>&#9733;</span>);
            }
        }

        return(
            <header className={`${classes.Header} u-relative u-width100Percent u-textColorWhite u-flex justify-content-between f-column`}>
                <div className={classes.Overlay}></div>
                <div className={classes.Slider}>
                    <div className={`u-width100Percent u-height100Percent`} style={{
                        transform: `translateX(${this.state.translateValue}px)`,
                        transition: 'transform ease-out 0.45s' 
                    }}>
                        {
                            this.props.hotelImages.map((image, i) => {
                                console.log(image.url);
                                return <SliderSlide key={i} image={encodeURI(image.url)} />
                            })
                        }
                    </div>
                </div>
                <div></div>
                <div className={`u-flex justify-content-between u-relative u-noWrapWithEllipsis u-zIndex9999`}>
                    <div>
                        <div>{stars}</div>
                        <h3 className={`u-fontSize24 u-fontWeightMedium u-textColorWhite u-phone-fontSize18 u-noWrapWithEllipsis u-width550`}>{this.props.detailContent.name}</h3>
                        <p className={`u-fontSize13 u-textColorWhite u-opacity60 u-phone-fontSize11`}><span className={`u-textColorWhite u-opacity100`}>{this.props.detailContent.address}</span></p>
                    </div>
                    <div className={`u-flex align-items-end`}>
                        <div className={`u-textAlignRight u-width120`}>
                            <p className={`u-fontSize26 u-fontWeightMedium u-textColorWhite u-phone-fontSize22`}>&#8377;{this.props.preferences[0][0].fareBreakup.find(fare => fare.key === "netFare").value.toLocaleString()}</p>
                            <p className={`u-fontSize13 u-phone-fontSize11`}>Starting Per Person</p>
                        </div>
                        <div className={`ml-4 align-self-center u-phoneHide`}>
                            <Button theme='Primary' type='Room' onClick={() => this.props.scrollClicked()}>Choose Room</Button>
                        </div>
                    </div>
                </div>
                <div className={`${classes.SliderControls} u-phoneHide`}>
                    <div className={`${classes.SliderControl} u-flex justify-content-center align-items-center`} onClick={this.goToNextSlide}>&#62;</div>
                    <div className={`${classes.SliderControl} u-flex justify-content-center align-items-center`} onClick={this.goToPrevSlide}>&#60;</div>
                </div>
                <div className={classes.SliderDots}>
                    {this.props.hotelImages.map((hotelImage, index) => <div key={index} className={[classes.SliderDot, this.state.currentIndex === index ? classes.SliderDotActive : null].join(' ')}></div>)}
                </div>
            </header>
        );
    }
}

const mapStateToProps = state => {
    return {
        hotelImages: state.hotels.hotelImages,
        detailContent: state.hotels.detailContent,
        detailStar: state.hotels.detailStar,
        preferences: state.hotels.preferences
    }
}

export default connect(mapStateToProps)(HotelHeader);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelHeader/HotelHeader.js